(function () {
  /* --- Produktkarte: Swatch-Hover wechselt das Hauptbild --- */
  if (!customElements.get('collection-showcase-card')) {
    class CShowCard extends HTMLElement {
      connectedCallback() {
        this.main = this.querySelector('[data-cshow-main]');
        this.swatches = Array.prototype.slice.call(this.querySelectorAll('[data-swatch]'));
        if (!this.main || !this.swatches.length) return;

        this.origSrc = this.main.getAttribute('src');
        this.selected = null; // null = Standard-Hauptbild

        this.swatches.forEach((sw) => {
          sw.addEventListener('mouseenter', () => this.preview(sw));
          sw.addEventListener('focus', () => this.preview(sw));
          sw.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(sw);
          });
        });

        this.addEventListener('mouseleave', () => this.applySelected());
      }

      setActive(sw) {
        this.swatches.forEach((s) => s.classList.toggle('is-active', s === sw));
      }

      setImage(url) {
        if (!url) return;
        // srcset/sizes entfernen, sonst ueberschreibt das Original-srcset das src
        this.main.removeAttribute('srcset');
        this.main.removeAttribute('sizes');
        this.main.src = url;
      }

      preview(sw) {
        this.setImage(sw.dataset.image);
        this.setActive(sw);
      }

      select(sw) {
        this.selected = sw;
        this.applySelected();
      }

      applySelected() {
        if (this.selected) {
          this.setImage(this.selected.dataset.image);
          this.setActive(this.selected);
        } else {
          this.setImage(this.origSrc);
          this.setActive(this.swatches[0]);
        }
      }
    }

    customElements.define('collection-showcase-card', CShowCard);
  }

  /* --- Slider: Pfeile scrollen um eine Kartenbreite --- */
  if (!customElements.get('collection-showcase-slider')) {
    class CShowSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cshow-track]');
        if (!this.track) return;

        var prev = this.querySelector('[data-cshow-prev]');
        var next = this.querySelector('[data-cshow-next]');
        if (prev) prev.addEventListener('click', () => this.scrollByCards(-1));
        if (next) next.addEventListener('click', () => this.scrollByCards(1));
      }

      scrollByCards(direction) {
        var card = this.track.querySelector('.cshow-card') || this.track.firstElementChild;
        if (!card) return;
        var styles = getComputedStyle(this.track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        var amount = card.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }
    }

    customElements.define('collection-showcase-slider', CShowSlider);
  }
})();
